import { TextField } from '@mui/material'
import { Controller, Control, FieldErrors } from 'react-hook-form'

interface PasswordFieldProps {
  name: string
  label: string
  control: Control<any>
  errors: FieldErrors<any>
  disabled?: boolean
  fullWidth?: boolean
  margin?: 'none' | 'dense' | 'normal'
}

export default function PasswordField({
  name,
  label,
  control,
  errors,
  disabled = false,
  fullWidth = true,
  margin = 'normal',
}: PasswordFieldProps) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { name: fieldName, value, onChange, onBlur, ref } }) => (
        <TextField
          name={fieldName}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          ref={ref}
          label={label}
          type='password'
          fullWidth={fullWidth}
          margin={margin}
          disabled={disabled}
          error={!!errors[name]}
          helperText={errors[name] ? (errors[name] as any)?.message : ''}
        />
      )}
    />
  )
}